import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const JobMatchesIcon = ({ className, fill = "#4D4D4D" }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177378_25310)">
        <path
          d="M6 8C8.206 8 10 6.206 10 4C10 1.794 8.206 0 6 0C3.794 0 2 1.794 2 4C2 6.206 3.794 8 6 8ZM6 1.33333C7.47067 1.33333 8.66667 2.52933 8.66667 4C8.66667 5.47067 7.47067 6.66667 6 6.66667C4.52933 6.66667 3.33333 5.47067 3.33333 4C3.33333 2.52933 4.52933 1.33333 6 1.33333ZM14.3333 9.33333H10.3333C9.41467 9.33333 8.66667 10.0807 8.66667 11V16H16V11C16 10.0807 15.252 9.33333 14.3333 9.33333ZM14.6667 14.6667H10V11C10 10.8167 10.1493 10.6667 10.3333 10.6667H14.3333C14.5173 10.6667 14.6667 10.8167 14.6667 11V14.6667ZM11.3333 11.3333H13.3333V12.6667H11.3333V11.3333ZM6 11.9967L7.33333 10.4967V12.5033L6 14.0033L3.05133 10.686C2.08133 10.8233 1.33333 11.6593 1.33333 12.6667V16H0V12.6667C0 10.8287 1.49533 9.33333 3.33333 9.33333H3.63267L6 11.9967Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_177378_25310">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default JobMatchesIcon;
